import t from "react";
import { s as l } from "./styled-38387a7e.js";
import { c as r, C as a } from "./Chip-992cd8db.js";
const s = l(e)(({ theme: o }) => ({
  ...o.typography.body2,
  color: o.palette.darkBlue.c70,
  borderColor: o.palette.darkBlue.c70,
  [`&.${r.filledPrimary}.${r.colorPrimary}`]: {
    backgroundColor: o.palette.lightBlue.c100,
    color: o.palette.common.white
  }
}));
function e(o) {
  return /* @__PURE__ */ t.createElement(a, { ...o });
}
export {
  s as M
};
